module.exports = "https://cdn.hellotech.com/client-assets/networking-mobile_7ffea2d353e1810275987a2a313882f8.jpg";